import React from 'react';
import { Services } from '../Services/Services';
import { TableServices } from '../Services/TableServices';
import { useViewPort } from '../Hooks/useViewPort';
import { AlertInstructions } from '../Services/AlertInstructions';
import { Button, Modal } from 'react-bootstrap';
import { SlidingPane } from '../SlidingPane';
import ProgressBar from 'react-bootstrap/ProgressBar';
import { GdacsTimeline } from "../Layout/GdacsTimeline";

const AlertsContainer = (props) => {
    const [addresses, setAddresses] = React.useState(props.params.addresses);
    const [services, setAServices] = React.useState(props.params.services);
    const { width } = useViewPort();
    const breakpoint = 620;
    const [isVisible, setIsVisible] = React.useState();
    const [navIndex, setNavIndex] = React.useState(props.navIndex);
    const [isButtonDisabled, setIsButtonDisabled] = React.useState(false);

    const handleChangeButton = (isButtonDisabled) => {
        props.isButtonDisabled(isButtonDisabled);
    }

    const handleChangeService = (services) => {
        props.onChange("services", services);
    }

    const handleInstructions = () => {
        setIsVisible(true);
    }

    React.useEffect(() => {
        props.onChange(addresses);
        props.isButtonDisabled(isButtonDisabled);
    }, [addresses]);

    React.useEffect(() => {
        props.onChange(services);
    }, [services, isButtonDisabled]);

    return width < breakpoint ? <div>
        <h4 className="d-flex justify-content-center hr-title">Select Your Notifications</h4>
        <br />
        {width > breakpoint &&
            <GdacsTimeline navIndex={navIndex} user={props.params.idUser} />

        }
        {width < breakpoint &&
            <>
                {props.params.idUser === 0 &&
                    <ProgressBar>
                        <ProgressBar variant={"YOU_PICK_A_NAME"} now={20}  />
                        <ProgressBar variant={"YOU_PICK_A_NAME"} now={20}  />
                <ProgressBar variant={"YOU_PICK_A_NAME"} now={20} now={20}  />
                <ProgressBar variant={"YOU_PICK_A_NAME"} now={20} now={20} label={4} />
                    </ProgressBar>
                }
                {props.params.idUser !== 0 &&
                    <ProgressBar>
                        <ProgressBar variant={"YOU_PICK_A_NAME"} now={25}  />
                <ProgressBar variant={"YOU_PICK_A_NAME"} now={25}  />
                <ProgressBar variant={"YOU_PICK_A_NAME"} now={25} label={3} />
                    </ProgressBar>
                }
            </>
        }
        <br />
        <br />

        <div className="p_summary">Select the notifications type (or disaster type), channel, region, alert level and language for your notifications.
        To receive a daily newsletter with the events of the past 24h, select the 'Newsletter' type. All other alerting services will send messages immediately after they have been detected by GDACS.
            </div>
        <br />
        <Services params={props.params} onChange={handleChangeService} isButtonDisabled={handleChangeButton} />
    </div> :
        <div>
            <h4 className="d-flex justify-content-center hr-title">Select Your Notifications</h4>
            <br />
            {width > breakpoint &&
                <GdacsTimeline navIndex={navIndex} user={props.params.idUser} />

            }
            {width < breakpoint &&
                <ProgressBar variant={"YOU_PICK_A_NAME"} now={100} label={props.params.idUser === 0 ? 5 : 4} />
            }
            <br />
            <br />
            <div className="p_summary">Select the notification type (or disaster type), channel, region, alert level and language for your notifications.
            To receive a daily newsletter with the events of the past 24h, select the 'Newsletter' type. All other alerting services will send messages immediately after they have been detected by GDACS.
            </div>
            <Button variant="link" className="float-right" onClick={handleInstructions} size="sm">How to configure your notifications</Button>
            <TableServices params={props.params} onChange={handleChangeService} isButtonDisabled={handleChangeButton} />
            <SlidingPane from="right" style={{ width: "90%" }} isOpen={isVisible} onRequestClose={() => { setIsVisible(false) }}>
                <AlertInstructions />
            </SlidingPane>
        </div>
}
export { AlertsContainer }